import { GameConstants } from "./GameConstants";
import { GameVars } from "./GameVars";

export class AudioManager {

    private static _instance: AudioManager = null;  
    
    public audioSprite: Phaser.AudioSprite;
    public audioStateBeforeMuting: boolean;

    private game: Phaser.Game;
    private _isAudioMuted: boolean;
    private _lastTimeCardSoundPlayed: number;

    public static getInstance(): AudioManager {

        if (AudioManager._instance === null) {
            AudioManager._instance = new AudioManager();
        }

        return AudioManager._instance;
    }

    constructor() {

        if (AudioManager._instance) {
            throw new Error("Error: Instantiation failed: Use AudioManager.getInstance() instead of new.");
        }

        AudioManager._instance = this;
    }

    public init(game: Phaser.Game): void {
        
        this.game = game;
        
        this.audioSprite = this.game.add.audioSprite("audio-sprite");  
        
        const audioMutedString = GameVars.getInstance().getLocalStorageData(GameConstants.AUDIO_MUTED_KEY);

        if ( audioMutedString !== "") {
            this._isAudioMuted = JSON.parse(audioMutedString);
            
            if ( this._isAudioMuted) {
                this.game.sound.mute = true;
            } 
        
        } else {
            this._isAudioMuted = false;
        }
        
        this._lastTimeCardSoundPlayed = 0;
    }

    public playSound(key: string): void {
        
        if (key.indexOf("cardfeed") > -1) {
            
            if (this.game.time.now - this._lastTimeCardSoundPlayed < 90) {
                return;
            }
            
            this._lastTimeCardSoundPlayed = this.game.time.now;
        }
            
        this.audioSprite.play(key);
    }

    public get isAudioMuted(): boolean {

        return this._isAudioMuted;
    }

    public set isAudioMuted(value: boolean) {
        
        // pq el explorer se queja
        if (this.audioSprite === null) {
            return;
        }

        this._isAudioMuted = value;

        if ( this._isAudioMuted) {
            this.game.sound.mute = true;
        } else {
            this.game.sound.mute = false;
        }
        
        GameVars.getInstance().setLocalStorageData(GameConstants.AUDIO_MUTED_KEY, JSON.stringify(this._isAudioMuted));      
    }
    
    public mute(): void {
        
        if (this.game) {
            this.audioStateBeforeMuting = this.isAudioMuted;
            this.game.sound.mute = true;
        }
    }
    
    public unmute(): void {
        
        if (this.game) {
            if (!this.audioStateBeforeMuting) {
                this.game.sound.mute = false;
            }
        }
    }
}
